export default __webpack_public_path__ + "static/media/green_checkmark.77254b63.svg";